import adminConstants from '../constants/admin';

const initialState = {
  data: null
}

export default function admin (state=initialState, action) {
  switch (action.type) {
    case adminConstants.CREATE_ADMIN:
      return {
        data: action.data
      };
    case adminConstants.UPDATE_ADMIN:
      return {
        data: action.data
      };
    case adminConstants.LOGIN_ADMIN:
      return {
        data: action.data
      };
    case adminConstants.LOGOUT_ADMIN:
      return {
        data: null
      };
    case adminConstants.FORGOT_PASSWORD_ADMIN:
      return {
        forgot: action.forgot
      };
    case adminConstants.RESET_PASSWORD_ADMIN:
      return {
        reset: action.reset
      };
    case adminConstants.CONFIRM_EMAIL:
      return {
        data: action.data
      };
    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/admin.js
 **/